<template>
  <div
    class="hero is-fullheight fullpage-section"
    data-anchor="section-new-welcome"
    :style="fondo"
  >
    <!-- NewWelcome content-->
    <div class="new-welcome-content">
      <div class="column height30"></div>

      <div class="columns is-centered" align="center">
        <img
          class="column height25p is-3-desktop is-9-mobile is-3-tablet is-30p-landscape is-centered"
          align="center"
          :src="getImg('common/logocalce-new.png')"
          alt
        />
      </div>

      <div class="column is-hidden-mobile is-centered">
        <h1
          class="is-size-1 hidden has-font-unicone has-text-white"
          align="center"
        >
          INNOVACIÓN QUE REHABILITA
        </h1>
      </div>

      <div class="column welcome-footer welcome-footer-letters">
        <div class="columns display-flex">
          <div class="column padding-top-button-off">
            <div class="columns margin-top-button-off">
              <div class="column is-2 is-hidden-desktop is-hidden-landscape paddingTop5"></div>
              <p class="margin-left-16p margin-top-1p">
                Asociaciones:
              </p>
            </div>
            <div
              class="columns is-mobile is-desktop is-4-mobile padding-top-button-off is-centered"
            >
              <!-- Asociaciones images-->
              <a
                class="column is-2-tablet is-2-mobile margin-right-left-off"
                rel="stylesheet"
                href="https://www.corfo.cl/sites/cpp/home"
                ><img :src="getImg('socios/Logo-Corfo.png')" alt=""
              /></a>

              <a
                class="column is-2-tablet is-2-mobile margin-right-left-off"
                rel="stylesheet"
                href="http://www.santiagoinnova.com/"
                ><img :src="getImg('socios/Logo-SantiagoInnova.png')" alt=""
              /></a>

              <a
                class="column is-2-tablet is-2-mobile margin-right-left-off"
                rel="stylesheet"
                href="https://isci.cl/"
                ><img :src="getImg('socios/Logo-ISCI.png')" alt=""
              /></a>

              <a
                class="column is-2-tablet is-2-mobile margin-right-left-off"
                rel="stylesheet"
                href="https://www.openbeauchef.cl/"
                ><img :src="getImg('socios/Logo-OpenBeauchef.png')" alt=""
              /></a>
            </div>
          </div>
          <div class="column padding-top-button-off">
            <div class="columns margin-top-button-off">
              <div
                class="column is-1 is-hidden-desktop padding-top-button-off"
              ></div>
              <p class="margin-left-8p margin-top-1p">Clientes:</p>
            </div>
            <div class="columns is-mobile padding-top-button-off is-centered">
              <!-- Clientes images-->

              <a
                class="column is-2-tablet is-2-mobile margin-right-left-off"
                rel="stylesheet"
                href="https://www.protexintegral.cl/"
                ><img :src="getImg('socios/Logo-Protek.png')" alt=""
              /></a>

              <a
                class="column is-2-tablet is-2-mobile margin-right-left-off"
                rel="stylesheet"
                href="https://cilefmedical.cl/"
                ><img :src="getImg('socios/Logo-Cilef.png')" alt=""
              /></a>

              <a
                class="column is-2-tablet is-2-mobile margin-right-left-off"
                rel="stylesheet"
                href="https://www.mutual.cl"
                ><img :src="getImg('socios/Logo-Mutual.png')" alt=""
              /></a>

              <a
                class="column is-2-tablet is-2-mobile margin-right-left-off"
                rel="stylesheet"
                href="http://ortopedianacional.cl/"
                ><img :src="getImg('socios/Logo-OrtopediaNacional.png')" alt=""
              /></a>

              <a
                class="column is-2-tablet is-2-mobile margin-right-left-off"
                rel="stylesheet"
                href="https://www.teleton.cl/"
                ><img :src="getImg('socios/Logo-Teleton.png')" alt=""
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImg } from "@/utils/AssetsHelper"
import { pageIsTouch } from "@/utils/config/viewportsConfig"
export default {
  methods: {
    getImg,
    isDesktop() {
      return !pageIsTouch(this.$currentViewport)
    }
  },
  data() {
    return {
      fondo: `background-image: url("${getImg(
        "fondos/fondoWelcome.jpg"
      )}"); background-size: cover`
    }
  }
}
</script>

<style scoped lang="scss">
.new-welcome-content {
  height: 100vh;
}

.new-welcome-content-mobile {
  height: 10vh;
}

.color-blanco {
  color: #afc1f6;
}

.welcome-footer {
  background: #4a4a4a;
  height: 15vh;
  bottom: 0;
  position: absolute;
  @media screen and (max-width: 1080px) {
    height: 20vh;
  }
}

@media screen and (max-height: 600px) {
  .hidden {
    display: none;
  }
}

@media (orientation: landscape) {
  .display-flex {
    display: flex;
  }
  .is-hidden-landscape {
    display: none;
  }

  @media screen and (max-height: 600px) {
    .is-30p-landscape {
      width: 25%;
    }
  }
}

.height-tecnologias {
  height: 12vh;
}

.padding-top-button-off {
  padding-top: 0;
  padding-bottom: 0;
}

.margin-right-left-off {
  padding-left: 0;
  padding-right: 0;
}

.margin-top-button-off {
  margin-bottom: 0;
  margin-top: 0;
}

.paddingTop5 {
  padding-top: 5px;
}

.welcome-footer-letters {
  color: #9ad9e9;
}

.height3 {
  height: 3vh;
}

.height15 {
  height: 15vh;
}

.height30 {
  height: 30vh;
}

.margin-left-16p {
  margin-left: 16.66667%;
}

.margin-left-8p {
  margin-left: 8.333335%;
}

.margin-top-1p {
  margin-top: 1%;
}

.height25p {
  height: 25%;
}

.height9 {
  height: 9vh;
}
</style>
